import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const NotFound = () => {
  const { language } = useLanguage();
  const isChinese = language === 'zh-TW';
  
  const content = {
    title: isChinese ? '找不到頁面' : 'Page Not Found',
    description: isChinese 
      ? '很抱歉，您嘗試訪問的頁面不存在或已被移動。' 
      : "Sorry, the page you were looking for doesn't exist or has been moved.",
    backHome: isChinese ? '返回首頁' : 'Back to Home'
  };
  
  return (
    <div className="max-w-lg mx-auto text-center py-16">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="mb-8 flex justify-center">
          <div className="p-6 bg-pink-100 dark:bg-pink-900/30 rounded-full">
            <SafeIcon 
              icon={FiIcons.FiAlertCircle} 
              className="w-16 h-16 text-pink-600 dark:text-pink-400" 
            />
          </div>
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
          404
        </h1>
        
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-6">
          {content.title}
        </h2>
        
        <p className="text-gray-600 dark:text-gray-300 mb-8">
          {content.description}
        </p>
        
        <Link 
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-medium rounded-lg transition-transform hover:scale-105"
        >
          <SafeIcon icon={FiIcons.FiHome} className="mr-2" />
          {content.backHome}
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;